<template>
    <div class="ukraine-popup">
        <p>
            {{ $t(`${TRANSLATION_KEY}.paragraphOneContent`) }}
        </p>
        <Radio
            :label="$t(`${TRANSLATION_KEY}.radioOne`)"
            name="ukraineAddress"
            :value="true"
            :checked="true"
            @update-value="ukraineAddress = $event"
        />
        <Radio
            :label="$t(`${TRANSLATION_KEY}.radioTwo`)"
            name="ukraineAddress"
            :value="false"
            @update-value="ukraineAddress = $event"
        />
        <button
            v-show="ukraineAddress"
            type="button"
            class="button button--submit"
            :disabled="ukraineAddress === null"
            @click="handleEuAddress"
        >
            {{ $t(`${TRANSLATION_KEY}.next`) }}
        </button>
        <button
            v-show="!ukraineAddress"
            type="button"
            class="button button--submit"
            :disabled="ukraineAddress === null"
            @click="handleRedirect"
        >
            {{ $t(`${TRANSLATION_KEY}.next`) }}
        </button>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import Radio from '@/components/basic/fields/Radio.vue';

export default defineComponent({
    name: 'UkraineResidenceInfo',
    components: {
        Radio,
    },
    props: {
        isOpen: Boolean,
    },
    emits: ['yesEuAddress'],
    setup(props, { emit }) {
        const ukraineAddress = ref<boolean>(true);
        const TRANSLATION_KEY = 'UkraineResidenceInfo';

        const handleRedirect = () => {
            window.location.replace('https://www.oanda.com/apply/');
        };

        const handleEuAddress = () => {
            emit('yesEuAddress');
        };

        return {
            ukraineAddress,
            TRANSLATION_KEY,
            handleRedirect,
            handleEuAddress,
        };
    },
});
</script>

<style lang="scss" scoped>
.ukraine-popup {
    p {
        margin: 0 0 25px;
        font-weight: 700;
        font-size: 12px;
    }
    .input-wrapper {
        margin-bottom: 30px;
    }
}
</style>
